// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.search-wrap .start-icon,
.search-wrap .end-icon {
  width: 1.5rem;
  height: 1.5rem;
  fill: var(--black-1000);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: 200ms all ease-in-out;
}
.search-wrap .start-icon {
  left: 1rem;
}
.search-wrap .end-icon {
  right: 1rem;
}
.search-wrap .search-input {
  width: 100%;
  min-height: 4rem;
  background-color: var(--quickSilver-1000);
  border: 0;
  border-radius: 1rem;
  box-shadow: 0px 4px 4px var(--black-250);
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  padding: 1rem 1rem;
  transition: 200ms all ease-in-out;
}
.search-wrap .search-input::placeholder {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  opacity: 1;
}
.search-wrap .search-input::-ms-input-placeholder {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  opacity: 1;
}
.search-wrap .search-input:has(:disabled) .search-wrap {
  opacity: 0.5;
  cursor: not-allowed;
}
.search-wrap:has(.start-icon) .search-input {
  padding-left: 3.5rem;
}
.search-wrap:has(.end-icon) .search-input {
  padding-right: 3.5rem;
}
@media screen and (max-width: 991.98px) {
  .search-wrap .search-input {
    min-height: 2.5rem;
    border-radius: 0.75rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
  .search-wrap .search-input::placeholder {
    font-size: 1rem;
  }
  .search-wrap .search-input::-ms-input-placeholder {
    font-size: 1rem;
  }
  .search-wrap .start-icon,
  .search-wrap .end-icon {
    width: 1.125rem;
    height: 1.125rem;
  }
  .search-wrap:has(.start-icon) .search-input {
    padding-left: 3.125rem;
  }
  .search-wrap:has(.end-icon) .search-input {
    padding-right: 3.125rem;
  }
}
@media screen and (max-width: 767.98px) {
  .search-wrap .search-input {
    min-height: 2.25rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
  }
  .search-wrap .start-icon,
  .search-wrap .end-icon {
    width: 1rem;
    height: 1rem;
  }
  .search-wrap:has(.start-icon) .search-input {
    padding-left: 3rem;
  }
  .search-wrap:has(.end-icon) .search-input {
    padding-right: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/SearchWidget/SearchWidgetStyle.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;;EAEE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,WAAA;AADJ;AAIE;EACE,WAAA;EACA,gBAAA;EACA,yCAAA;EACA,SAAA;EACA,mBAAA;EACA,wCAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AAFJ;AAII;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAFN;AAKI;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAHN;AAMI;EACE,YAAA;EACA,mBAAA;AAJN;AAQE;EACE,oBAAA;AANJ;AASE;EACE,qBAAA;AAPJ;AAUE;EACE;IACE,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,oBAAA;EARJ;EAUI;IACE,eAAA;EARN;EAWI;IACE,eAAA;EATN;EAaE;;IAEE,eAAA;IACA,gBAAA;EAXJ;EAcE;IACE,sBAAA;EAZJ;EAeE;IACE,uBAAA;EAbJ;AACF;AAgBE;EACE;IACE,mBAAA;IACA,qBAAA;IACA,mBAAA;IACA,oBAAA;EAdJ;EAiBE;;IAEE,WAAA;IACA,YAAA;EAfJ;EAkBE;IACE,kBAAA;EAhBJ;EAmBE;IACE,mBAAA;EAjBJ;AACF","sourcesContent":[".search-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  .start-icon, \n  .end-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n    fill: var(--black-1000);\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 200ms all ease-in-out;\n  }\n\n  .start-icon {\n    left: 1rem;\n  }\n  \n  .end-icon {\n    right: 1rem;\n  }\n  \n  .search-input {\n    width: 100%;\n    min-height: 4rem;\n    background-color: var(--quickSilver-1000);\n    border: 0;\n    border-radius: 1rem;\n    box-shadow: 0px 4px 4px var(--black-250);\n    color: var(--black-1000);\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    text-decoration: none;\n    padding: 1rem 1rem;\n    transition: 200ms all ease-in-out;\n\n    &::placeholder {\n      color: var(--black-1000);\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: 1;\n      opacity: 1;\n    }\n\n    &::-ms-input-placeholder {\n      color: var(--black-1000);\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: 1;\n      opacity: 1;\n    }\n\n    &:has(:disabled) .search-wrap {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  &:has(.start-icon) .search-input {\n    padding-left: 3.5rem;\n  }\n  \n  &:has(.end-icon) .search-input {\n    padding-right: 3.5rem;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .search-input {\n      min-height: 2.5rem;\n      border-radius: 0.75rem;\n      font-size: 1rem;\n      padding: 0.5rem 1rem;\n\n      &::placeholder {\n        font-size: 1rem;\n      }\n\n      &::-ms-input-placeholder {\n        font-size: 1rem;\n      }\n    }\n    \n    .start-icon, \n    .end-icon {\n      width: 1.125rem;\n      height: 1.125rem;\n    }\n\n    &:has(.start-icon) .search-input {\n      padding-left: 3.125rem;\n    }\n    \n    &:has(.end-icon) .search-input {\n      padding-right: 3.125rem;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    .search-input {\n      min-height: 2.25rem;\n      border-radius: 0.5rem;\n      font-size: 0.875rem;\n      padding: 0.5rem 1rem;\n    }\n    \n    .start-icon, \n    .end-icon {\n      width: 1rem;\n      height: 1rem;\n    }\n\n    &:has(.start-icon) .search-input {\n      padding-left: 3rem;\n    }\n    \n    &:has(.end-icon) .search-input {\n      padding-right: 3rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
